import { Grid, GridItem } from '@imported/constellation';
import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PageHeading } from '../../components/index.js';
import NeedHelp from '../../components/NeedHelp/index.js';
import TakeSelfieContentForm from '../../components/TakeSelfieContentForm/index.js';
import { useIdvProvider } from '../../context/index.js';
import { useLabelContext } from '../../context/LabelContext.js';
import { ROUTE_PATHS } from '../../utils/routePaths.js';
const TakeSelfieContent = () => {
    const [description, setDescription] = useState([]);
    const navigate = useNavigate();
    const { idvState } = useIdvProvider();
    const { getLabelFromContext } = useLabelContext();
    const imageUrl = [
        `${idvState.assetsPath}/images/Selfie-Good.jpg`,
        `${idvState.assetsPath}/images/Selfie-Bad.jpg`,
    ];
    const handleTakePhotoContentSubmission = useCallback(() => {
        navigate(`../${ROUTE_PATHS.SELFIE_PHOTO}`);
    }, [navigate]);
    const handlePreviousPage = useCallback(() => {
        navigate(`../${ROUTE_PATHS.TAKE_PHOTO_CONTENT}`);
    }, [navigate]);
    useEffect(() => {
        setDescription(getLabelFromContext('components.takeSelfieContentForm.selfie.desc'));
    }, [getLabelFromContext]);
    return (React.createElement(React.Fragment, null,
        React.createElement(PageHeading, { journeyTitle: idvState.labels.applicationHeading, pageTitle: getLabelFromContext('containers.takeSelfieContent.pageTitle') }),
        React.createElement(Grid, null,
            React.createElement(GridItem, { md: 8, sm: 12 },
                React.createElement(TakeSelfieContentForm, { description: description, imageUrl: imageUrl, handlePreviousPage: handlePreviousPage, handleTakePhotoContentSubmission: handleTakePhotoContentSubmission })),
            React.createElement(GridItem, { md: 4, sm: 12 },
                React.createElement(NeedHelp, null)))));
};
export default TakeSelfieContent;
//# sourceMappingURL=index.js.map